<i18n src="./resources/locales.json"></i18n>
<template>
  <div>
    <div class="primary-title xtium-title">{{ $t('typography') }}</div>
    <v-select
      hide-details
      :disabled="disableControls"
      :items="fonts"
      :label="$t('selectFont')"
      :value="theme.getFont"
      @change="fontChange"
    >
      <template slot="item" slot-scope="data">
        <span :style="{ fontFamily: data.item }">{{ data.item }}</span>
      </template>
      <template slot="selection" slot-scope="data">
        <span :style="{ fontFamily: theme.getFont }">{{ data.item }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EcsDisableControlsMixin from '@/mixins/EcsDisableControlsMixin';

export default {
  name: 'EcsFontPicker',
  data() {
    return {
      fonts: [
        'Roboto Slab',
        'Merriweather',
        'Playfair Display',
        'PT Serif',
        'Lora',
        'Noto Serif',
        'Crimson Text',
        'Slabo 27px',
        'Libre Baskerville',
        'Bitter',
        'Roboto',
        'Open Sans',
        'Lato',
        'Noto Sans JP',
        'Montserrat',
        'Roboto Condensed',
        'Source Sans Pro',
        'Oswald',
        'Raleway',
        'Poppins',
        'Roboto Mono',
        'Ubuntu',
        'Muli',
        'Open Sans Condensed',
        'Nunito'
      ]
    };
  },
  mixins: [EcsDisableControlsMixin],
  computed: mapGetters(['theme']),
  methods: {
    ...mapActions(['setFont']),
    fontChange(font) {
      this.setFont({ payload: font, vuetify: this.$vuetify });
    }
  }
};
</script>

<style scoped>
.card-container {
  width: 100%;
}
</style>
